<template>
  <MultiAssignField
    type="select"
    label="Brand"
    name="brands"
    :options="brandOptions"
    :value="assigned"
  />
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    course: { type: Object, default: () => {} },
    brands: { type: Array, default: () => [] },
  },

  data() {
    return {
      assigned: [],
    };
  },

  computed: {
    brandOptions() {
      return this.brands.filter((brand) => {
        if (!this.course) {
          return true;
        } else {
          return !!this.course.brands.find((b) => b.id == brand.value);
        }
      });
    },
  },

  watch: {
    course(val) {
      this.prune();
    },
  },

  methods: {
    prune() {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter((a) => {
        return !!this.brandOptions.find((b) => b.value == a);
      });
    },
  },

  mounted() {
    this.assigned = this.event._brands || [];
  },
};
</script>